import { resolveConditionTree } from '@/features/order/order-form/lib/resolve-condition-tree'
import type { ConditionKind } from '@/features/order/order-form/lib/trigger-condition-model'
import type { OrderFormCollapsibleConfig } from '@/state/order'

// Short header-badge label per condition kind. AND/OR collapse to "Composite".
const KIND_LABELS: Record<ConditionKind, string> = {
  price: 'Price trigger',
  technical_indicator: 'Indicator',
  returns: 'Return',
  candle: 'Candle',
  portfolio_metric: 'Portfolio',
  position_stats: 'Position',
  risk_metric: 'Risk',
  option_iv: 'Option IV',
  schedule: 'Schedule',
  db_news: 'News',
  action_event: 'Order event',
  and: 'Composite',
  or: 'Composite',
}

/**
 * Short label describing the configured trigger, for the section header badge.
 * Reads the structured tree first (authoritative), falling back to the legacy
 * flat config — same resolution order as the submit path. Returns null when
 * there's no usable condition.
 */
export function triggerSummaryLabel(
  config: OrderFormCollapsibleConfig | null | undefined
): string | null {
  const root = resolveConditionTree(config)
  if (!root) return null

  return KIND_LABELS[root.kind] ?? 'Trigger'
}
